import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface I_Provision {
  role: string;
  status: string;
  id: string;
  name: string;
  email: string;
}

interface ProvisionState {
  approvedUsers: I_Provision[];
  pendingUsers: I_Provision[];
  loading: boolean;
}

const initialState: ProvisionState = {
  approvedUsers: [],
  pendingUsers: [],
  loading: false,
};

const provisionSlice = createSlice({
  name: "provision",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setApprovedUsers: (state, action) => {
      state.approvedUsers = action.payload;
    },
    setPendingUsers: (state, action) => {
      state.pendingUsers = action.payload;
    },
    moveUserToApproved: (state, action) => {
      const { id, role } = action.payload;
      const userIndex = state.pendingUsers.findIndex(user => user.id === id);
      if (userIndex !== -1) {
        const user = state.pendingUsers[userIndex];
        state.pendingUsers.splice(userIndex, 1);
        state.approvedUsers.push({
          ...user,
          role: role.toUpperCase(),
          status: "ACTIVE"
        });
      }
    },
    removeUserFromPending: (state, action) => {
      state.pendingUsers = state.pendingUsers.filter(user => user.id !== action.payload);
    },
    updateUserRole: (state, action) => {
      const { id, newRole } = action.payload;
      const userIndex = state.approvedUsers.findIndex(user => user.id === id);
      if (userIndex !== -1) {
        state.approvedUsers[userIndex].role = newRole.toUpperCase();
      }
    },
    updateUserStatus: (state, action) => {
      const { id, status } = action.payload;
      const userIndex = state.approvedUsers.findIndex(user => user.id === id);
      if (userIndex !== -1) {
        state.approvedUsers[userIndex].status = status;
      }
    },
  },
});

export const {
  setLoading,
  setApprovedUsers,
  setPendingUsers,
  moveUserToApproved,
  removeUserFromPending,
  updateUserRole,
  updateUserStatus,
} = provisionSlice.actions;

export const getProvisionState = (state: { provision: ProvisionState }) => state.provision;

export default provisionSlice.reducer;